import { Col, Row } from "antd";
import { generalCreditSortOrder, isArticulation } from "utils/creditUtils";

import { CREDIT_TYPES } from "common/model/creditType";
import CreditItem from "./CreditItem";
import React from "react";
import classes from "./CreditList.module.scss";
import { isEmpty } from "lodash";

export const ArticulationCreditList = (props) => {
  const groupedArticulations = props.groupedArticulations || {};
  if (isEmpty(groupedArticulations)) return null;

  const articulationKeys = Object.keys(groupedArticulations) || [];
  const creditBookmarks = props.creditBookmarks;

  const isMobile = props.isMobile;
  if (isMobile) {
    return articulationKeys.map((articulation) => {
      return (
        <CreditItem
          key={`credit-item-${articulation.ID}`}
          itemBlocks={groupedArticulations[articulation]}
          creditType={CREDIT_TYPES.ARTICULATION}
          selectedSourceInstitution={props.selectedSourceInstitution}
          creditBookmarks={creditBookmarks}
          isMobile={isMobile}
        />
      );
    });
  }

  return articulationKeys.map((articulationKey) => {
    const itemBlocks = groupedArticulations[articulationKey].sort(
      generalCreditSortOrder,
    );
    return (
      <div
        id="articulation-credit-list"
        style={{ marginBottom: 12 }}
        key={articulationKey}
      >
        <CreditItem
          itemBlocks={itemBlocks}
          selectedSourceInstitution={props.selectedSourceInstitution}
          creditType={CREDIT_TYPES.ARTICULATION}
          creditBookmarks={creditBookmarks}
          isMobile={isMobile}
        />
      </div>
    );
  });
};

export const PrecedentCreditList = (props) => {
  const precedents = props.precedents || [];
  const creditBookmarks = props.creditBookmarks;
  const isMobile = props.isMobile;

  if (isMobile) {
    return precedents.map((precedent) => (
      <CreditItem
        key={precedent.ID}
        itemBlocks={[precedent]}
        creditType={CREDIT_TYPES.PRECEDENT}
        selectedSourceInstitution={props.selectedSourceInstitution}
        creditBookmarks={creditBookmarks}
        isMobile={isMobile}
      />
    ));
  }
  return precedents.map((precedent) => {
    return (
      <div style={{ marginBottom: 12 }} key={precedent.ID}>
        <CreditItem
          itemBlocks={[precedent]}
          creditType={CREDIT_TYPES.PRECEDENT}
          selectedSourceInstitution={props.selectedSourceInstitution}
          creditBookmarks={creditBookmarks}
          isMobile={isMobile}
        />
      </div>
    );
  });
};

export class CourseCreditList extends React.Component {
  state = {
    showDetails: false,
  };
  getTotalCredits = (credentials) => {
    let total = 0;

    credentials.forEach((credential) => {
      if (isArticulation(credential.type)) {
        credential.arrangements.forEach((arrangement) => {
          total += arrangement.specified;
          total += arrangement.unspecified;
        });
      } else {
        credential?.subjects?.forEach((subject) => {
          total += subject.creditPoints;
        });
      }
    });
    return total;
  };

  render() {
    const {
      credentials,
      creditBookmarks,
      isMobile,
      selectedSourceInstitution,
    } = this.props;

    if (isEmpty(credentials)) {
      return null;
    }

    if (!credentials[0].course) {
    }

    const title = (
      <div>
        <a
          href={credentials[0].course.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {credentials[0].course.name}{" "}
        </a>
      </div>
    );

    return (
      <div
        className={
          isMobile ? classes.courseCreditItemsMobile : classes.courseCreditItems
        }
      >
        {isMobile ? (
          <>
            <Row className={classes.courseCreditHeaderSectionMobile}>
              <Col
                span={24}
                className={`${classes.institutionLabel} source-institution-label`}
              >
                {title}
              </Col>
            </Row>
          </>
        ) : (
          <Row className={classes.courseCreditHeaderSection}>
            <Col
              span={24}
              className={`${classes.institutionLabel} source-institution-label`}
            >
              <div>{title}</div>
            </Col>
          </Row>
        )}

        <div>
          {credentials.map((credential) => (
            <CreditItem
              key={credential.ID}
              itemBlocks={[credential]}
              creditType={credential.type}
              selectedSourceInstitution={selectedSourceInstitution}
              creditBookmarks={creditBookmarks}
              isMobile={isMobile}
              inCourseBlock={true}
            />
          ))}
        </div>
      </div>
    );
  }
}
